import {useInitAbTest} from 'modules/ab-tests/hooks/useInitAbTest';
import {AB_EXPRESS_ORDER} from 'modules/ab-tests/constants';
import {useGetAbTest} from 'modules/ab-tests/hooks/getAbTest';
import {useGetExpressOrderQuery} from 'modules/products/services';
import {useIsWorker} from 'core/hooks/useIsWorker';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {useEffect} from 'react';
import {useExpressOrderGtag} from 'hooks/analytics/gtag/catalog/useExpressOrderGtag';

export const AB_EXPRESS_ORDER_MAP = {
    ['winery_in_header']: 'new',
    ['no_winery_in_header']: 'original',
};

export const useInitAbExpressOrder = () => {
    return useInitAbTest({abTestName: AB_EXPRESS_ORDER});
};

export const useGetAbExpressOrder = () => {
    const {data: result, isSuccess} = useGetAbTest({abTestName: AB_EXPRESS_ORDER});

    const isWorker = useIsWorker();
    const isPrive = useIsPrive();

    const abValue = result?.[AB_EXPRESS_ORDER] as keyof typeof AB_EXPRESS_ORDER_MAP;
    const shouldShowExpressOrder = Boolean(abValue) && 'new' === AB_EXPRESS_ORDER_MAP[abValue];
    const expressOrderResponse = useGetExpressOrderQuery(undefined, {
        skip: !shouldShowExpressOrder,
    });

    const {sendVisitEvent} = useExpressOrderGtag();

    useEffect(() => {
        const wineryTitle = expressOrderResponse?.data?.data?.titleVinoteki ?? 'winery_not_set';

        // eslint-disable-next-line no-console
        console.log(`ab HeaderWinery: ${JSON.stringify(result)}`);
        if (isSuccess) {
            sendVisitEvent(`${AB_EXPRESS_ORDER_MAP[abValue]} ${wineryTitle}`);
        }
    }, [abValue, expressOrderResponse?.data?.data?.titleVinoteki, isSuccess, result, sendVisitEvent]);

    if (expressOrderResponse?.data?.isHidden || isWorker || isPrive) {
        return {isActive: false, value: abValue};
    }

    return {isActive: shouldShowExpressOrder, value: abValue};
};
